module.exports = __webpack_public_path__ + "static/media/dtj-mockup-7.19c9e0a0.jpg";